module.exports = "/images/footer_logo.png?2ca887c62cc3561625a8eed3131b6c25";